module.exports = __webpack_public_path__ + "img/goods12.920bd1c9.jpg";